import { computed, inject, Provider, signal } from '@angular/core';
import { AuthenticationService } from 'authentication-data';
import { NavItemType, provideNavItems } from 'navigation-data';
import { provideQuotesFeatureRoutes } from './quotes-feature.routes';

export function provideQuotesFeature(): Provider {
  return [
    provideQuotesFeatureRoutes(),
    provideNavItems({
      type: NavItemType.RouteLink,
      id: 'app.main-menu/quotes',
      label: signal($localize`:@@MainMenu_QuotesTitle:Quotes`),
      icon: signal('request_quote'),
      priority: signal(60),
      command: signal([`/quotes`]),
      hidden: () => {
        const auth = inject(AuthenticationService);
        return computed(() => !auth.isAuthenticated() || !auth.user()?.customerNumbers?.length);
      },
    }),
  ];
}
